(function () {
  if (window.__ossGlobalVariantPickerReady) return;
  window.__ossGlobalVariantPickerReady = true;

  var modal;
  var optionsNode;
  var titleNode;
  var addButton;
  var activeForm = null;
  var selectedVariantId = '';
  var returnFocus = null;
  var lockedScrollY = 0;
  var productCache = {};

  function getModal() {
    modal = modal || document.querySelector('[data-oss-global-variant-modal]');
    if (!modal) return null;
    optionsNode = optionsNode || modal.querySelector('[data-oss-global-variant-options]');
    titleNode = titleNode || modal.querySelector('[data-oss-global-variant-title]');
    addButton = addButton || modal.querySelector('[data-oss-global-variant-add]');
    return modal;
  }

  function parseEmbeddedVariants(form) {
    var node = form && form.querySelector('[data-oss-card-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]').filter(function (variant) {
        return variant && variant.available !== false;
      });
    } catch (error) {
      return [];
    }
  }

  function currencyCode() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
  }

  function formatRemotePrice(value) {
    if (typeof value === 'string' && /[^0-9.]/.test(value)) return value;
    var cents = Number(value || 0);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode()
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function normalizeRemoteVariants(product) {
    return (product && product.variants ? product.variants : []).filter(function (variant) {
      return variant.available !== false;
    }).map(function (variant) {
      return {
        id: variant.id,
        title: variant.title,
        price: formatRemotePrice(variant.price),
        available: variant.available
      };
    });
  }

  function productHandle(form) {
    return form.getAttribute('data-product-handle') ||
      (form.closest('[data-product-handle]') && form.closest('[data-product-handle]').getAttribute('data-product-handle')) || '';
  }

  function loadVariants(form) {
    var embedded = parseEmbeddedVariants(form);
    if (embedded.length) return Promise.resolve(embedded);
    var handle = productHandle(form);
    if (!handle) return Promise.resolve([]);
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load product options');
        return response.json();
      }).then(normalizeRemoteVariants).catch(function () {
        return [];
      });
    }
    return productCache[handle];
  }

  function lockPage() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('oss-variant-selector-open');
    document.body.classList.add('oss-variant-selector-open');
  }

  function unlockPage() {
    document.documentElement.classList.remove('oss-variant-selector-open');
    document.body.classList.remove('oss-variant-selector-open');
    if (Math.abs((window.scrollY || window.pageYOffset || 0) - lockedScrollY) > 1) {
      window.scrollTo(0, lockedScrollY);
    }
  }

  function closeModal(restoreFocus) {
    if (!getModal() || modal.hidden) return;
    modal.classList.remove('is-open');
    window.setTimeout(function () {
      modal.hidden = true;
      unlockPage();
      if (restoreFocus !== false && returnFocus && document.contains(returnFocus)) returnFocus.focus();
      activeForm = null;
      selectedVariantId = '';
    }, 180);
  }

  function selectOption(button) {
    if (!optionsNode || !button) return;
    optionsNode.querySelectorAll('button').forEach(function (option) {
      var selected = option === button;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    selectedVariantId = button.getAttribute('data-variant-id') || '';
    if (addButton) addButton.disabled = !selectedVariantId;
  }

  function openModal(form, variants, trigger) {
    if (!getModal() || !optionsNode || !variants.length) return;
    activeForm = form;
    returnFocus = trigger || null;
    var card = form.closest('.oss-product-card, .oss-wishlist-card');
    var cardTitle = card && card.querySelector('h3');
    var title = form.getAttribute('data-product-title') ||
      (cardTitle ? cardTitle.textContent : '') ||
      'Select an option';
    titleNode.textContent = title.trim();
    optionsNode.innerHTML = variants.map(function (variant, index) {
      return '<button type="button" data-variant-id="' + String(variant.id) + '" aria-pressed="' + (index === 0 ? 'true' : 'false') + '" class="' + (index === 0 ? 'is-selected' : '') + '">' +
        '<span>' + escapeHtml(variant.title || 'Default') + '</span>' +
        '<strong>' + escapeHtml(variant.price || '') + '</strong>' +
      '</button>';
    }).join('');
    selectedVariantId = String(variants[0].id);
    addButton.disabled = false;
    modal.hidden = false;
    lockPage();
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var first = optionsNode.querySelector('button');
      if (first) first.focus();
    });
  }

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = String(value == null ? '' : value);
    return node.innerHTML;
  }

  function addVariant(form, variantId) {
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = variantId;
    if (typeof window.ossAjaxCartAddVariant === 'function') {
      return window.ossAjaxCartAddVariant(form, variantId, 1);
    }
    form.submit();
    return Promise.resolve();
  }

  function setTriggerLoading(trigger, loading) {
    if (!trigger) return;
    if (loading) {
      if (!trigger.hasAttribute('data-oss-original-label')) {
        trigger.setAttribute('data-oss-original-label', trigger.textContent.trim());
      }
      trigger.textContent = 'Loading options...';
      trigger.disabled = true;
      return;
    }
    var originalLabel = trigger.getAttribute('data-oss-original-label');
    if (originalLabel) trigger.textContent = originalLabel;
    trigger.removeAttribute('data-oss-original-label');
    trigger.disabled = false;
  }

  function handleQuickAdd(form, trigger) {
    if (!form || form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    setTriggerLoading(trigger, true);
    loadVariants(form).then(function (variants) {
      if (variants.length > 1) {
        openModal(form, variants, trigger);
        return;
      }
      var fallbackId = form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value;
      var variantId = variants.length ? variants[0].id : fallbackId;
      if (variantId) return addVariant(form, variantId);
    }).finally(function () {
      form.removeAttribute('aria-busy');
      if (trigger) trigger.removeAttribute('aria-busy');
      setTriggerLoading(trigger, false);
    });
  }

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-oss-global-variant-close]');
    if (close) {
      event.preventDefault();
      closeModal(true);
      return;
    }
    var option = event.target.closest('[data-oss-global-variant-options] button');
    if (option) {
      event.preventDefault();
      selectOption(option);
      return;
    }
    var add = event.target.closest('[data-oss-global-variant-add]');
    if (add && activeForm && selectedVariantId) {
      event.preventDefault();
      add.disabled = true;
      closeModal(false);
      addVariant(activeForm, selectedVariantId).finally(function () {
        add.disabled = false;
      });
      return;
    }
    var trigger = event.target.closest('[data-oss-global-quick-add]');
    if (!trigger) return;
    var form = trigger.closest('[data-oss-global-variant-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    handleQuickAdd(form, trigger);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && getModal() && !modal.hidden) closeModal(true);
  });
})();
